import { useMemo } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import atomDark from 'react-syntax-highlighter/dist/esm/styles/prism/atom-dark';
import oneLight from 'react-syntax-highlighter/dist/esm/styles/prism/one-light';

import { Flex, useTheme } from '@raystack/apsara';

import styles from './Codeblock.module.css';

interface CustomCodeBlockProps {
  language?: string;
  value: string;
}

export const CustomCodeBlock: React.FC<CustomCodeBlockProps> = ({
  language = 'javascript',
  value
}) => {
  const { resolvedTheme } = useTheme();

  const themeStyle = useMemo(() => {
    return resolvedTheme === 'dark' ? atomDark : oneLight;
  }, [resolvedTheme]);

  return (
    <Flex className={styles.layout} direction='column' align='start'>
      <SyntaxHighlighter
        language={language}
        style={themeStyle}
        className={styles.codeBlock}
      >
        {value}
      </SyntaxHighlighter>
    </Flex>
  );
};
